import React, { useState, useContext } from 'react';
import { useHistory } from 'react-router-dom';
import { Context } from 'app/AppContext';
import axios from 'utils/axios';
import{
  Section, Container, ContactSelect,
} from 'components';
import {
  Title, Content, Description, InputWrapper, Label,
  Input, TextArea, Wrapper, Button,
} from './style';

interface Props {
  isHome: boolean,
}

declare global {
  interface Window {
    fbq: any;
  }
}

const Contact: React.FC<Props> = ({isHome = false}) => {
  const [selectOpen, setSelectOpen] = useState(false);
  const [phone, setPhone] = useState('');
  const [email, setEmail] = useState('');
  const [path, setPath] = useState('');
  const [shop, setShop] = useState('');
  const [content, setContent] = useState('');
  const context = useContext(Context);
  const history = useHistory()

  const onChangePath = (path: string) => {
    setPath(path);
    setSelectOpen(false);
  }

  const onSubmit = async (_: any) => {
    // eslint-disable-next-line
    const emailRe = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    
    if (phone.length < 1) {
      context.setMessage('전화번호를 입력해주세요', 'error');
    } else if (email.length < 1) {
      context.setMessage('이메일을 입력해주세요', 'error');
    } else if (!emailRe.test(String(email).toLowerCase())) {
      context.setMessage('이메일을 형식을 확인해주세요', 'warning');
    } else if (path.length < 1) {
      context.setMessage('알게된 경로를 선택해주세요', 'error');
    } else if (shop.length < 1) {
      context.setMessage('매장명과 지역을 입력해주세요', 'error');
    } else if (content.length < 1) {
      context.setMessage('문의 내용을 입력해주세요', 'error');
    } else {
      try{
        await axios.post('/ceo/contact/', {
          phone,
          email,
          path,
          shop,
          content,
        });
        window.fbq('track', 'Contact');
        history.push('/contact/success')
      } catch (err) {
        const res = err.response;
        if (res.status === 500) {
          context.setMessage('문제가 발생했습니다. 나중에 다시 시도해주세요', 'error');
        } else if (res.status === 400) {
          context.setMessage('올바른 내용인지 확인해주세요', 'warning');
        }
      }
    }
  }

  return (
    <Wrapper isHome={isHome}>
      <Section minHeight={250}>
        <h1>코로나19로 힘드시죠?<br/>매출, 지금 잡아야 합니다. 같이 극복해요 사장님!</h1>
        {
          !isHome ? (
            <a href="/case">사장님 인터뷰 보기</a>
          ) : null
        }
      </Section>

      <Description>
        <Container>
          <Title>제휴 문의 및 제안서 요청하기</Title>
          <Content>
            현금 비용 없이 효과적으로 홍보하실 수 있습니다.<br/>
            원활한 상담을 위해 아래 정보를 입력해 주시면 빠른 시간 내로 연락 드리도록 하겠습니다.
          </Content>

          <InputWrapper>
            <Label>전화번호</Label>
            <Input
              type="tel"
              placeholder="-없이 번호만 입력해 주세요."
              onChange={(event) => setPhone(event.target.value.replace(/[^0-9]/, ''))}
              value={phone}
            />
          </InputWrapper>

          <InputWrapper>
            <Label>이메일</Label>
            <Input
              type="email"
              placeholder="예) ceo@datepop.co.kr"
              onChange={(event) => setEmail(event.target.value)}
              value={email}
            />
          </InputWrapper>

          <InputWrapper>
            <Label>알게된 경로</Label>
            <ContactSelect
              isOpen={selectOpen}
              selectedValue={path}
              onClickSelect={() => setSelectOpen(!selectOpen)}
              onClickOption={(path: string) => onChangePath(path)}
              onOutsideClick={() => setSelectOpen(false)}
            />
          </InputWrapper>

          <InputWrapper>
            <Label>매장명 / 지역</Label>
            <Input
              type="text"
              placeholder="예) 퍼기클라우드 / 서울 길동"
              onChange={(event) => setShop(event.target.value)}
              value={shop}
            />
          </InputWrapper>

          <InputWrapper>
            <Label>문의 내용</Label>
            <TextArea
              placeholder="문의하실 내용을 자유롭게 작성해주세요."
              onChange={(event) => setContent(event.target.value)}
              value={content}
            />
          </InputWrapper>

          <Button onClick={onSubmit}>문의하기</Button>
        </Container>
      </Description>
    </Wrapper>
  );
};

export default Contact;
